import React, { useRef, useMemo } from "react";
import { JoinedAlert } from "../../../types";
import { useListTrapSitesQuery } from "../../../actions/trapsiteInQuery";
import { useListDevicesQuery } from "../../../actions/devicesInQuery";
import { useMaintenanceAlerts } from "../../../hooks/useAppAlerts";
import { MaintenanceAlert } from "./MaintenanceAlert";
import "./index.css";

type Props = {
  // Extra props go here
};

const Index: React.FC<Props> = () => {
  const listContainerRef = useRef<HTMLDivElement>(null);

  const { data: trapSitesData, isLoading: isTrapSiteLoading } =
    useListTrapSitesQuery();
  const { data: devices, isLoading: isDevicesLoading } = useListDevicesQuery();
  const {
    data: alerts,
    hasDevices,
    isLoading: isAlertsLoading,
  } = useMaintenanceAlerts();

  const joinedAlerts = useMemo(() => {
    if (!alerts?.items || !hasDevices) {
      return [];
    }

    let result: JoinedAlert[] = [];

    const latestByDevice = new Map<string, (typeof alerts.items)[0]>();
    alerts.items.forEach((alert) => {
      const deviceKey = alert.device ?? "_no_device";
      const existing = latestByDevice.get(deviceKey);
      if (
        !existing ||
        new Date(alert.created_at) > new Date(existing.created_at)
      ) {
        latestByDevice.set(deviceKey, alert);
      }
    });

    latestByDevice.forEach((alert) => {
      const device = devices?.items?.find((d) => d.uuid === alert.device);

      const trapsite = trapSitesData?.items?.find((t) => {
        return t._id === device?.trap_site_id;
      });

      result.push({
        ...alert,
        device_name: device?.display_name || "",
        trap_name: trapsite?.display_name || "",
      });
    });

    return result;
  }, [alerts, devices, trapSitesData, hasDevices]);

  return (
    <MaintenanceAlert
      loading={isTrapSiteLoading || isDevicesLoading || isAlertsLoading}
      listContainerRef={listContainerRef}
      joinedAlerts={joinedAlerts}
    />
  );
};

export default Index;
